import Typography from "@mui/material/Typography";

import style from "./Explore_3.module.css";
import PageButton from "../../components/PageButton";

function Explore_3_3() {
  return (
    <div style={{ height: "100%" }}>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          height: "calc(100vh - 100px)",
        }}
      >
        <div>
          <Typography className={style.wordsbox2}>
            既然如此，你已經準備好創業家精神了嗎？
          </Typography>
        </div>
      </div>
      <div className={style.pageBtn}>
        <PageButton passPath={"/explore-4"} nextPath={"/explore-4"} />
      </div>
    </div>
  );
}

export default Explore_3_3;
